import type { NavItem, ContactInfo, Event } from '../types';

export const siteConfig = {
  name: 'Sternwarte Mannheim',
  tagline: 'Alte Sternwarte Mannheim - Historische astronomische Sternwarte und Kulturzentrum',
  organization: 'Verein Stadtbild Mannheim e.V. - Aktionsbündnis Alte Sternwarte',
  url: 'https://sternwarte-mannheim.de',
};

export const navigation: NavItem[] = [
  { title: 'Startseite', url: '/' },
  { title: 'Aktuelles & Termine', url: '/termine' },
  {
    title: 'Alte Sternwarte',
    url: '/about',
    submenu: [
      { title: 'Geschichte', url: '/about' },
      { title: 'Astronomen & Forschung', url: '/astronomen' },
      { title: 'Künstler*innen', url: '/kuenstler' },
      { title: 'Renovierung 2008-2015', url: '/renovierung' },
      { title: 'Baumaßnahmen 2016-heute', url: '/erweiterungen' },
    ],
  },
  {
    title: 'Aktionsbündnis',
    url: '/aktionsbuendnis',
    submenu: [
      { title: 'Über uns', url: '/ueber-uns' },
      { title: 'LeseZeichen', url: '/lesezeichen' },
      { title: 'Literatur', url: '/literatur' },
      { title: 'Presse + Medien', url: '/presse' },
      { title: 'Unterstützen', url: '/unterstuetzen' },
    ],
  },
  { title: 'Kontakt', url: '/kontakt' },
];

export const contactInfo: ContactInfo = {
  address: {
    street: 'A4,6',
    postalCode: '68159',
    city: 'Mannheim',
    country: 'Deutschland',
  },
  email: {
    general: 'kontakt@sternwarte-mannheim.de',
    events: 'veranstaltungen@sternwarte-mannheim.de',
  },
  parking: [
    'Tiefgarage Universität/Mensa, Bismarckstr. 12 (günstige Tarife, ca. 100 m zu Fuß)',
    'Tiefgarage D5 (rem-Museum), 300 m Fußweg',
  ],
  publicTransport: {
    tram: [
      "Linien 1, 5, 6, 7, 15: Haltestelle 'Schloss Mannheim' (ca. 300-400 m)",
      "Linien 2, 3, 6: Haltestelle 'Rathaus/REM' (ca. 350 m)",
    ],
    bus: [
      "Linien 14, 60, 65: Haltestelle 'Schloss Mannheim'",
      "Linien 60, 65: Haltestelle 'Mensa am Schloss' (direkt vor der Sternwarte)",
    ],
  },
  accessibilityNote: 'Die Sternwarte ist nicht barrierefrei. 190 Stufen bis zum Dach.',
};

export const upcomingEvents: Event[] = [
  {
    id: '1',
    type: 'LITERARISCHER SPAZIERGANG',
    date: '2026-02-08',
    time: '15:30 Uhr',
    title: "Literarischer Spaziergang: 'Hungersnot und Dürre in der Literatur'",
    description:
      "Vor dem Hintergrund der Ausstellung 'Margaret Courtney-Clarke: Geographies of Drought' gestalten LeseZeichen-Mitglieder einen literarischen Spaziergang mit Texten, die Trockenheit, Nahrungsknappheit und andere Naturkatastrophen literarisch verarbeiten.",
    location: 'im REM (Peter und Traudl Engelhornhaus, C4, 12)',
    organizer: 'LeseZeichen',
    admission: 'Eintritt für den Besuch der Ausstellung ist zu bezahlen',
    status: 'available',
  },
  {
    id: '2',
    type: 'BESICHTIGUNG',
    date: '2026-03-22',
    time: '11 – 13 Uhr',
    title: 'Offene Sternwarte',
    description:
      'Freie Besichtigung der Sternwarte mit Atelier Stallwitz, Infos in den Stockwerken, Ausblick über Mannheim und die Kurpfalz',
    admission: 'Eintritt frei, um eine Spende wird gebeten',
    status: 'available',
    detailContent: {
      location: 'A4,6 / Bismarckstraße, 68159 Mannheim neben der Jesuitenkirche / Ursulinenschule',
      activities: [
        'Informationen über die Geschichte der Sternwarte in den einzelnen Stockwerken',
        'Infos über Astronomie und Bedeutung als Vermessungspunkt',
        'Besichtigung des Ateliers von Walter Stallwitz (verstorben 2022) im 2. OG',
        'Grandioser Rundblick über Mannheim – Ludwigshafen und die Kurpfalz vom Dach',
      ],
      notes: [
        'Die Sternwarte ist nicht barrierefrei, 190 Stufen bis zum Dach',
        'Im Turm ist es meistens kühl, auf dem Dach kann es recht windig sein',
        'Bitte achten Sie darauf, dass auf dem Dach die Brüstung nicht bestiegen werden darf',
      ],
    },
  },
  {
    id: '3',
    type: 'FÜHRUNG',
    date: '2026-03-25',
    time: '18:00 Uhr',
    title: 'Sternwarte zwischen Tag und Nacht',
    description: 'Führung durch die Sternwarte, Aussicht vom Turm bei Tag und bei Nacht',
    status: 'booked',
    guide: 'Reinhard Betz',
    registration: 'veranstaltungen@sternwarte-mannheim.de',
    admission: 'Eintritt frei, um eine Spende wird gebeten',
    detailContent: {
      meetingPoint: 'Hof der Sternwarte, rechts vom Haupteingang (68159 Mannheim, A 4, 6 / Bismarckstraße)',
      program: [
        'Betrachtung der Außenfassade und Erläuterungen zum Bau',
        'Aufstieg durch 5 Stockwerke mit Erklärungen zu ehemaliger Nutzung',
        'Informationen über Christian Mayer und Kurfürst Carl Theodor',
        'Ausblick bei Tageslicht und Sonnenuntergang',
        "PowerPoint-Präsentation im 5. OG (ca. 20 min): Historie, Christian Mayer, Carl Theodor",
        "'Monnem by night' und Lichtermeer der BASF nach Eintritt der Dunkelheit",
      ],
      notes: ['Nicht barrierefrei', 'Im Turm meist kühl, auf der Plattform sehr windig', 'Geeignete Kleidung empfohlen'],
    },
  },
  {
    id: '4',
    type: 'STERNENBEOBACHTUNG',
    date: '2026-04-15',
    time: '21:00 – 23:00',
    title: 'Nachtspaziergang am Sternenhimmel',
    description: 'Astronomische Beobachtungen auf der Sternwarte',
    status: 'available',
    guide: 'Felix Becher',
    maxParticipants: 15,
    registration: 'veranstaltungen@sternwarte-mannheim.de',
    detailContent: {
      concept:
        'Auf der Alten Mannheimer Sternwarte einmal selbst Astronom*In sein und Wunder des Sternhimmels mit eigenen Augen beobachten',
      targetGroup: 'Erwachsene sowie Jugendliche ab 13 Jahren',
      duration: 'ca. 2 Stunden',
      meetingPoint: 'Eingang der Alten Sternwarte (A4,6, 68159 Mannheim)',
      admissionTime: 'Ab 15 Minuten vor Beginn, später Einlass nicht möglich',
      weatherNote:
        'Die Veranstalter prüfen die Wetterbedingungen im Vorfeld und informieren bei Absage per E-Mail (Spam-Ordner prüfen!)',
      cancellationPolicy:
        'Bei Verhinderung bitte zeitnahe Benachrichtigung, damit Personen von der Warteliste nachrücken können',
    },
  },
];

export const historyContent = {
  summary:
    'Die Alte Sternwarte Mannheim gehört zu den ältesten Gebäuden der Stadt und ist für Baden-Württemberg einzigartig. Von 1775 bis 1880 wurde hier astronomische Forschung betrieben.',
  keyFacts: [
    { label: 'Gründung', value: '1772 (Grundsteinlegung am 1. Oktober 1772)' },
    { label: 'Baukosten', value: 'ca. 19.000 Gulden (Gebäude) + 83.000 Gulden (mit Instrumenten)' },
    { label: 'Forschungszeitraum', value: '1775-1880' },
    { label: 'Berühmte Besucher', value: 'Wolfgang Amadeus Mozart, Thomas Jefferson, De Lalande, Lexell, Olbers, Bessel' },
  ],
  sections: [
    {
      title: 'Gründung',
      content:
        'Der Bau der Mannheimer Sternwarte wurde von dem Hofastronomen Christian Mayer initiiert, geplant und überwacht. Die Rückreise von St. Petersburg hatte Mayer dazu genutzt, die Sternwarten in Åbo, Stockholm, Kopenhagen, Lübeck, Hamburg, Hannover, Göttingen und Kassel zu besuchen. Der italienische Architekt Rabaliatti und der Artillerie-Leutnant Johann Lacher setzten Mayers Vorstellungen um.',
    },
    {
      title: 'Nutzung nach 1880',
      content:
        'Nach 1880 wurde die Sternwarte für astronomische Zwecke nicht mehr genutzt. Der Turm wurde von der Stadt Mannheim vermietet und ab 1957 zu einem Atelierturm umgebaut.',
    },
    {
      title: 'Nach 1945',
      content:
        'Nach dem Zweiten Weltkrieg und den Zerstörungen in Mannheim wurde die Sternwarte als eines der wenigen historischen Gebäude des Barockensembles erhalten.',
    },
  ],
};

export const astronomers = [
  { name: 'Christian Mayer', years: '1719-1783', role: 'Hofastronom' },
  { name: 'Karl Joseph König', years: 'gest. 1809', role: 'Astronom' },
  { name: 'Johann Nepomuk Fischer', years: '1749-1805', role: 'Astronom' },
  { name: 'Roger Barry', years: '1752-1813', role: 'Astronom' },
  { name: 'Heinrich Christian Schumacher', years: '1780-1850', role: 'Astronom' },
  { name: 'Friedrich Bernhard Gottfried Nicolai', years: '1793-1846', role: 'Astronom' },
  { name: 'Eduard Schönfeld', years: '1828-1891', role: 'Astronom' },
  { name: 'Carl Wilhelm Friedrich Johann Valentiner', years: '1845-1931', role: 'Astronom' },
];

export const artistsByFloor = [
  {
    floor: '1. OG',
    artists: [
      { name: 'Karl Trummer', years: '1937-1957' },
      { name: 'Leo Labusch', years: '1984-1989' },
      { name: 'Jens Trimpin', years: '1989-2014' },
    ],
  },
  {
    floor: '2. OG',
    artists: [
      { name: 'Hermann Taglang', years: '1908-1924' },
      { name: 'Franz Albert Schumacher', years: '1946-1958' },
      { name: 'Gerd Dehof', years: '1958-1984' },
      { name: 'Walter Stallwitz', years: '1958-2022' },
    ],
  },
  {
    floor: '3. OG',
    artists: [
      { name: 'Walter Koch', years: '1985-1988' },
      { name: 'Uta Dorra', years: '1998-2014' },
    ],
  },
  {
    floor: '4. OG',
    artists: [
      { name: 'Paul Berger-Bergner', years: '1958-1987' },
      { name: 'Norbert Nüssle', years: '1983-2003' },
      { name: 'Ruth Hutter', years: '2004-2011' },
    ],
  },
  {
    floor: '5. OG',
    artists: [
      { name: 'Franz Schömbs', years: '1947-1957' },
      { name: 'Hans Nagel', years: '1959-1963' },
      { name: 'Edgar Schmandt', years: '1963-2019' },
    ],
  },
];

export const renovationTimeline = [
  { year: '2008/2009', event: 'Erste Bemühungen zur Rettung der Sternwarte – ohne Erfolg. Anfrage zur Situation der Sternwarte im Landtag von Helen Heberer (MdL)' },
  { year: '2010', event: "'Runder Tisch Sternwarte' entsteht. Benefizveranstaltungen für die Sanierung" },
  { year: '2011', event: "Gründung 'Aktionsbündnis Alte Sternwarte'. Festakt im Mannheimer Schloss" },
  { year: '2012', event: 'Beschluss zur Sanierung der Außenfassade. Benefizveranstaltungen' },
  { year: '2013', event: 'Bauarbeiten beginnen. Benefizveranstaltungen. Fördergelder' },
  { year: '2014', event: 'Denkmal des Monats. Weitere Benefizveranstaltungen. Fördergelder und Spenden' },
  { year: '2015', event: 'Abschluss der Außenrenovierung. Großes Sternwartenfest. Künstlerausstellung' },
];

export const recentTimeline = [
  { year: '2016', event: 'Sternwarte erhält eine Außenbeleuchtung' },
  { year: '2017', event: 'Sternwarte wieder für die Öffentlichkeit zugänglich' },
  { year: '2018', event: 'Konzerte, Lesungen und Vorträge in der Sternwarte' },
  { year: '2019', event: "Sternwarte erhält ihre Kuppel wieder. Christian Mayer 300. Geburtstag – Feier am Tag des Offenen Denkmals" },
  { year: '2020', event: 'Baubeginn des lang ersehnten Anbaus' },
  { year: '2021', event: 'Der Anbau nimmt Gestalt an' },
  { year: '2022', event: "'Hemmersche Fünfspitz' montiert – Fest zum Jubiläum der Grundsteinlegung" },
];

export const books = [
  {
    title: 'A4,6 – Künstlerinnen und Künstler in der Alten Sternwarte Mannheim',
    publisher: 'Wellhöfer Verlag, 2015',
    language: 'Deutsch',
    pages: '140',
    features: 'mit vielen Abbildungen',
    isbn: '978-3954281749',
    price: '25 Euro',
    description:
      'Die Alte Sternwarte Mannheim ist eines der ältesten noch existierenden Bauwerke des Barock in Mannheim. Seit 1908 lebten und arbeiteten dort Künstler.',
  },
  {
    title: 'Sternwarte Mannheim - Geschichte der Mannheimer Sternwarte 1772-1880',
    publisher: 'Verlag Regionalkultur, 2006 (Herausgegeben vom Landesmuseum für Technik und Arbeit)',
    series: 'Technik + Arbeit Nr. 12',
    language: 'Deutsch',
    pages: '200',
    features: 'mit 76, überwiegend farbigen Abb., fester Einband',
    isbn: '3-89735-473-X',
    price: '17,90 Euro',
    description: 'Das erste Buch zur Mannheimer Sternwarte erzählt die Geschichte der Sternwarte bis zum Jahr 1880.',
  },
];

export const pressArticles = [
  { year: '2014', source: 'Mannheimer Morgen', title: 'Sternwarte zum Denkmal des Monats ernannt' },
  { year: '2019', source: 'Echo Online Darmstadt', title: 'Neue Beobachtungskuppel für historische Mannheimer Sternwarte' },
  { year: '2019', source: 'Deutsche Stiftung Denkmalschutz', title: 'Alte Sternwarte Mannheim erhält Abschluss wieder', date: '14.10.2019' },
  { year: '2022', source: 'Mannheimer Morgen: Zeitreise', title: 'Alte Sternwarte Mannheim – landesweit einzigartig', date: '01.10.2022' },
  { year: '2022', source: 'Mannheimer Morgen', title: 'Lesezeichen - Lesung in der Sternwarte – junge Autorin mit Roman zu Armenien', date: '16.05.2022' },
  { year: '2022', source: 'Mannheimer Morgen', title: "Gelungene 'Wiedererweckung': Die Mannheimer Sternwarte - Feier zur beendeten Sanierung und zum 250. Jahrestag der Grundsteinlegung", date: '04.10.2022' },
  { year: '2022', source: 'SWR aktuell', title: 'Alte Sternwarte in Mannheim feiert 250-jähriges Bestehen - Großes Jubiläumswochenende', date: '30.09.2022' },
  { year: '2022', source: 'Mannheimer Morgen', title: 'Ausstellung in der Alten Sternwarte gewährt künstlerischen Blick ins All - 250 Jahre Sternwarte – 114 Jahre Kunst in der Sternwarte', date: '13.10.2022' },
  { year: '2022', source: 'Die Rheinpfalz', title: 'Griff nach den Sternen: Ausstellung in der Alten Sternwarte', date: '11.10.2022' },
];

export const donationInfo = {
  recipient: 'Verein Stadtbild Mannheim e.V',
  iban: 'DE77 6705 0505 0038 6368 20',
  bank: 'Sparkasse Rhein Neckar Nord',
  reference: 'Alte Sternwarte',
  taxNote:
    'Der Verein Stadtbild e.V. garantiert die Verwendung der Spenden im Sinne des Aktionsbündnisses und stellt Spendenbescheinigungen aus',
};
